import { OmniIconComponent, OmniDropdownComponent } from '../../../../shared/components/omni-components';
import '../../../../styles/movePlacementForm.scss';

/**
 * MovePlacementForm Component
 * 
 * IMPORTANT NOTE ABOUT OMNI DROPDOWN:
 * The OmniDropdown component is a Web Component that uses Shadow DOM.
 * When onDropdownChange is triggered, it returns an object in e.detail.value[0]:
 * {
 *   value: "placement_taxonomy",  // Display text
 *   code: "id",                  // Package ID
 *   label: "placement_taxonomy"   // Same as value
 * }
 */
const MovePlacementForm = ({
    isOpen,
    onClose,
    packages,
    selectedPackageId,
    onPackageSelect,
    onMove,
    disabled
}) => {
    if (!isOpen) return null;

    return (
        <div className="move-placement-modal-container">
            <div className="move-placement-modal modal is-active">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="modal-header-title">
                            Move Placement
                        </div>
                        <hr className="modal-header-divider" />
                        <div className="modal-header-description">
                            Select a destination package you would like to move your placement to
                        </div>
                    </div>
                    
                    <div className="modal-middle-section">
                        <div className="dropdown-section">
                            <label htmlFor="move-placement-dropdown" className="dropdown-section-label">
                                Select Package
                            </label>
                            <OmniDropdownComponent
                                typeahead
                                hidefooter
                                searchindropdown
                                options={packages.map(pkg => ({
                                    value: pkg.placement_taxonomy,
                                    code: pkg.id.toString(),
                                    label: pkg.placement_taxonomy
                                }))}
                                hoisted="true"
                                placeholder="Select package"
                                value={selectedPackageId ? [{
                                    value: packages.find(p => p.id.toString() === selectedPackageId)?.placement_taxonomy,
                                    code: selectedPackageId,
                                    label: packages.find(p => p.id.toString() === selectedPackageId)?.placement_taxonomy
                                }] : []}
                                id="move-placement-dropdown"
                                className="move-placement-dropdown"
                                onDropdownChange={(e) => {
                                    const selectedOption = e.detail;
                                    onPackageSelect(selectedOption?.code);
                                }}
                                tooltipOnOverflow={true}
                            />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <div className="modal-button-group">
                            <button 
                                className="tertiary" 
                                onClick={onClose}
                                type="button"
                            >
                                Cancel
                            </button>
                            <button 
                                className={disabled ? 'is-disabled' : ''}
                                onClick={onMove}
                                disabled={disabled}
                                type="button"
                            >
                                Move
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MovePlacementForm;
